import { mergeQueryTypes }     from '../util/network/QueryUtility';
import { SystemRecordQueries } from './SystemRecordQueries';
import { QuerySetKeys }        from '../types';

const querySets = [
	SystemRecordQueries,
];

type QuerySegmentType<D extends QuerySetKeys> =
	typeof SystemRecordQueries[D];

const SystemQueries = {
	fragments: mergeQueryTypes( querySets, 'fragments' ) as QuerySegmentType<'fragments'>,
	queries:   mergeQueryTypes( querySets, 'queries' ) as QuerySegmentType<'queries'>,
	mutations: mergeQueryTypes( querySets, 'mutations' ) as QuerySegmentType<'mutations'>,
};

export { SystemQueries }

